export default __webpack_public_path__ + "static/media/payment_success.c794b63a.svg";